import {
  useCallback,
  useRef,
  useState,
} from "react"

/*
 * this is like useState but only for state objects
 *
 * this behaves differently from useState because the "addState" function
 * adds new values to the current state without deleting the old state
 */
export function useStateObject<T>(initialValue: T): [T, typeof addState] {
  const [
    value,
    setValue,
  ] = useState<T>(initialValue)
  const ref = useRef<T>(value)

  const addState = useCallback<typeof setValue>(
    (newValue) => {
      ref.current = {
        ...ref.current,
        ...newValue,
      }

      setValue(ref.current)
    },
    [setValue],
  )

  return [
    value,
    addState,
  ]
}
